var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrightnessHigh = function SvgIconBrightnessHigh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.082a.5.5 0 1 0 1 0V3.08a.5.5 0 0 0-1 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.757 16.824a6 6 0 1 1 8.485-8.485 6 6 0 0 1-8.485 8.485m.707-.707 7.071-7.07a5 5 0 1 0-7.07 7.07",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.002 12.58a.5.5 0 0 1-.5.5h-2a.5.5 0 1 1 0-1h2a.5.5 0 0 1 .5.5M4.502 13.08a.5.5 0 0 0 0-1H2.5a.5.5 0 1 0 0 1zM12 22.582a.5.5 0 0 1-.5-.5v-2a.5.5 0 1 1 1 0v2a.5.5 0 0 1-.5.5M3.93 20.652a.5.5 0 0 1 0-.707l1.414-1.414a.5.5 0 1 1 .707.707l-1.414 1.414a.5.5 0 0 1-.708 0M17.95 5.925a.5.5 0 1 0 .707.708l1.416-1.416a.5.5 0 1 0-.708-.707zM20.072 20.652a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707M5.345 6.633a.5.5 0 1 0 .708-.707L4.637 4.51a.5.5 0 1 0-.707.707z"
  })));
};
export default SvgIconBrightnessHigh;